export const isFilmPagePath = (pathname = "") =>
  pathname === "/film-page" || pathname.startsWith("/film-page/");

/**
 * Profile routes may intentionally render another user's public data.
 * Film routes are account actions, so their provider scope must never be
 * inherited from navigation state or sessionStorage (including a newly opened
 * tab that the browser initialized from a friend's profile tab).
 */
export const resolveLayoutUserId = ({
  pathname = "",
  authUserId = null,
  urlUserId = null,
  stateUserId = null,
  storedUserId = null
}: { pathname?: string; authUserId?: string | null; urlUserId?: string | null; stateUserId?: string | null; storedUserId?: string | null } = {}) => {
  if (isFilmPagePath(pathname)) return authUserId || null;
  return urlUserId || stateUserId || storedUserId || authUserId || null;
};
